import { Markdown } from "../components/Markdown"
import { ForestTemplate } from "../templates/ForestTemplate"

export function CaliforniaPage() {
  return (
    <ForestTemplate title="California Reception - Blake & Christie">
      <Markdown path="california.md" />
    </ForestTemplate>
  )
}
